import { DialogContent, DialogTitle, Stack } from "@mui/material";
import { materialGoodsIssueBusiness } from "api/bussiness/material/material-goods-issue";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { DynamicFormArray } from "commons/ultilities/dynamic-form/components/dynamic-form-array";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import { IControl } from "commons/ultilities/dynamic-form/models/control";
import { createMaterialOptionLabel } from "commons/ultilities/option-item/label-ultil";
import { observer } from "mobx-react-lite";
import { IUpdateMaterialGoodsIssue } from "mobx-stores/_models/material-inventory/material-goods-issue/material-goods-issue";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect, useMemo } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { useGoodsIssueItemHandlers } from "../hooks/use-goods-issue-item-handlers";
import { getUpdateMaterialGoodsIssueSchema } from "./schema";

export const UpdateMaterialGoodsIssue = observer(() => {
  const {
    materialInventoryManagement: {
      materialGoodsIssueStore: {
        openEdit,
        getMaterialGoodsIssue,
        materialGoodsIssueDetail,
        setProp,
      },
    },
  } = useStores();
  const {
    form: { controls, isValid },
    getControl,
    getArrayItemControl,
    submitHandler,
    setDefaults,
  } = useForm<IUpdateMaterialGoodsIssue>(getUpdateMaterialGoodsIssueSchema(), {
    id: materialGoodsIssueDetail?.id,
    issueDate: materialGoodsIssueDetail?.issueDate,
    items: [],
  });

  const getBrandControl = useCallback(
    (rowIndex: number) => getArrayItemControl("items", rowIndex, "brand"),
    [getArrayItemControl],
  );

  const { itemValueChangedHandler, updateBrandOptionsByMaterial } =
    useGoodsIssueItemHandlers({
      getBrandControl,
    });

  useEffect(() => {
    if (materialGoodsIssueDetail) {
      setDefaults({
        id: materialGoodsIssueDetail?.id,
        issueDate: materialGoodsIssueDetail?.issueDate,
        items: materialGoodsIssueDetail.items.map((x) => ({
          id: x.id,
          materialId: x.materialId,
          amount: x.amount,
          workOrderId: x.workOrderId,
          workOrderPOId: x.workOrderPOId,
          department: x.department,
          brand: x.brand,
          note: x.note,
        })),
      });

      if (
        materialGoodsIssueDetail.items &&
        materialGoodsIssueDetail.items.length > 0
      ) {
        getControl("items").children.forEach((row: IControl[], rowIndex) => {
          const idCtr = row.filter((x) => x.name === "id")?.[0];
          const data = materialGoodsIssueDetail.items.filter(
            (x) => idCtr && x.id === idCtr.value,
          )?.[0];

          const materialIdCtr = row.filter((x) => x.name === "materialId")?.[0];
          if (materialIdCtr && data?.material) {
            materialIdCtr.setProp("optionItems", [
              {
                label: createMaterialOptionLabel(data.material),
                value: data.material?.id,
              },
            ]);
          }

          const woCtr = row.filter((x) => x.name === "workOrderPOId")?.[0];
          if (woCtr && data.workOrderPO) {
            woCtr.setProp("optionItems", [
              {
                value: data?.workOrderPOId,
                label: `${data?.workOrderPO?.woNumber || ""}`,
              },
            ]);
          }

          void updateBrandOptionsByMaterial(rowIndex, data?.materialId);
        });
      }
    }
  }, [
    getControl,
    materialGoodsIssueDetail,
    setDefaults,
    updateBrandOptionsByMaterial,
  ]);

  const saveHandler = useCallback(
    async (data: IUpdateMaterialGoodsIssue) => {
      try {
        if (!materialGoodsIssueDetail?.id) return;
        await materialGoodsIssueBusiness.update(
          materialGoodsIssueDetail?.id,
          data,
        );
        await getMaterialGoodsIssue();
        setProp("openEdit", false);
      } catch (ex) {
        console.error(ex);
      }
    },
    [getMaterialGoodsIssue, materialGoodsIssueDetail?.id, setProp],
  );

  const itemsControl = useMemo(() => {
    return getControl("items").children;
  }, [getControl]);

  return (
    <DialogForm
      open={openEdit}
      fullWidth
      maxWidth={"sm"}
      onClose={() => setProp("openEdit", false)}
      onCancelBtnClicked={() => setProp("openEdit", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Sửa xuất kho</DialogTitle>
      <DialogContent>
        <Stack sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
          {itemsControl && itemsControl.length > 0 && (
            <DynamicFormArray
              controlSpacing={2}
              children={itemsControl}
              onValueChanged={itemValueChangedHandler}
            ></DynamicFormArray>
          )}
        </Stack>
      </DialogContent>
    </DialogForm>
  );
});
